import React, { useEffect, useState, useRef } from "react"
import DfbHeadline from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline"
import Section from "@dfb/gatsby-dfb-theme/src/components/blocks/section"
import CConsentBanner from "@dfb/gatsby-dfb-theme/src/components/elements/c_consent_banner"

const MSocialWall = ({ data }) => {
  const { headline } = data
  const [consent, setConsent] = useState(false)
  const contentRef = useRef(null)

  const serviceName = "walls.io"

  //check and update the consent status
  useEffect(() => {
    const handleConsentEvent = e => {
      if (e.detail && e.detail.event === "consent_status") {
        setConsent(Boolean(e.detail[serviceName]))
      }
    }

    window.addEventListener("ucEvent", handleConsentEvent)

    return () => {
      window.removeEventListener("ucEvent", handleConsentEvent) // Cleanup event listener
    }
  }, [])

  const loadWallsIoScript = () => {
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.async = true
    script.src = "https://walls.io/js/wallsio-widget-1.2.js"
    script.setAttribute(
      "data-wallurl",
      "https://my.walls.io/dfb-de?nobackground=1&amp;show_header=0&amp;show_post_info=1&amp;accessibility=0&amp;initial_posts=6&amp;lang=de_DE&amp;columns=3",
    )
    script.setAttribute("data-title", "Social Wall")
    script.setAttribute("data-width", "100%")
    script.setAttribute("data-autoheight", "1")
    script.setAttribute("data-injectloadmorebutton", "true")
    script.setAttribute("data-loadmoretext", "Mehr laden")
    script.setAttribute("data-loadmorecount", "6")
    script.setAttribute("data-lazyload", "1")

    script.onload = () => {
      console.log("Walls.io script loaded successfully")
    }

    script.onerror = () => {
      console.error("Error loading Walls.io script")
    }

    if (contentRef.current) {
      contentRef.current.appendChild(script)
    }
  }

  // Function to clear the Walls.io widget content
  const clearWallsIoContent = () => {
    if (contentRef.current) {
      contentRef.current.innerHTML = "" // Clear all child elements
    }
  }

  useEffect(() => {
    if (consent) {
      loadWallsIoScript()
    } else {
      clearWallsIoContent()
    }

    return () => {
      clearWallsIoContent() // Cleanup when component unmounts or consent changes
    }
  }, [consent])

  return (
    <Section
      baseClass="m-SocialWall"
      defaultPaddingTop="large"
      defaultPaddingBottom="extra-large"
      data={data}
    >
      <div className="m-SocialWall-wrapper">
        <div className="m-SocialWall-container">
          {headline && (
            <div className="c-Headline m-SocialWall-headline">
              <DfbHeadline
                headline={headline}
                headline_level="h3"
                add_class="c-Headline-strokeLine"
              />
            </div>
          )}
          <div className="m-SocialWall-content" ref={contentRef}></div>
        </div>
        <CConsentBanner serviceName="walls.io" />
      </div>
    </Section>
  )
}

export default MSocialWall
